module.exports = __webpack_public_path__ + "img/banner20230425.d0b5b192.jpg";